import { useTags } from "@/hooks/use-tags";
import { useLocation } from "wouter";

interface TagDisplayProps {
  content: string;
  className?: string;
}

export function TagDisplay({ content, className = "" }: TagDisplayProps) {
  const { highlightTags, tags } = useTags();
  const [, setLocation] = useLocation();

  const handleTagClick = (tagName: string) => {
    const match = tags.find(
      (t) => t.name.toLowerCase() === tagName.toLowerCase(),
    );
    if (match) {
      setLocation(`/tags/${match.id}`);
    } else {
      setLocation(`/search?tag=${encodeURIComponent(tagName)}`);
    }
  };

  const highlightedContent = highlightTags(content, handleTagClick);

  return (
    <div className={`whitespace-pre-wrap ${className}`}>{highlightedContent}</div>
  );
}

interface TagDisplayInlineProps {
  content: string;
  maxLength?: number;
  className?: string;
}

export function TagDisplayInline({
  content,
  maxLength = 100,
  className = "",
}: TagDisplayInlineProps) {
  const { highlightTags, tags } = useTags();
  const [, setLocation] = useLocation();

  const handleTagClick = (tagName: string) => {
    const match = tags.find(
      (t) => t.name.toLowerCase() === tagName.toLowerCase(),
    );
    if (match) {
      setLocation(`/tags/${match.id}`);
    } else {
      setLocation(`/search?tag=${encodeURIComponent(tagName)}`);
    }
  };

  let displayContent = content;
  if (content.length > maxLength) {
    displayContent = content.substring(0, maxLength) + "...";
  }

  const highlightedContent = highlightTags(displayContent, handleTagClick);

  return <div className={`inline ${className}`}>{highlightedContent}</div>;
}
